import React from 'react';

export class FullScreen extends React.Component {
	getCentered() {
		return this.props.centered ? "vertical-center-flex" : "top-center-flex";
	}
	render() {
		return (
			<div className={`full-screen`}>
				<div
					className={`full-screen__container  ${this.getCentered()}`}
				>
					{this.props.children}
				</div>
			</div>
		);
	}
}